const toggle = document.querySelector("#mobile-nav-toggle");
const nav = document.querySelector(".header .header__nav");

toggle.addEventListener("click", () => {
  document.body.classList.toggle("header__nav--visible");
});
